import { render, staticRenderFns } from "./meteria_class.vue?vue&type=template&id=468b955e&scoped=true"
import script from "./meteria_class.vue?vue&type=script&lang=ts"
export * from "./meteria_class.vue?vue&type=script&lang=ts"
import style0 from "./meteria_class.vue?vue&type=style&index=0&id=468b955e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b955e",
  null
  
)

export default component.exports